import gql from "graphql-tag";

export const APPOINTMENT_TYPES_QUERY = gql`
  query AppointmentTypesQuery {
    appointmentTypes {
      id
      name
      description
      duration
      url
    }
  }
`;
